<template>
     <div v-show="parent3Show">
        <Form ref="formItem" :model="formItem" :rules="formValidate" :label-width="100">
            <Form-item label="规则名称" prop="name">
                <Input type="text" v-model="formItem.name" placeholder="请输入"></Input>
            </Form-item>
            <Form-item label="规则类型" prop="type">
                <Select v-model="formItem.type" @on-change="selChangeFn" placeholder="请选择">
                    <Option v-for="(item,index) in typeSel" :key="index" :value="item.val">{{item.name}}</Option>
                </Select>
            </Form-item>
            <Form-item label="规则设置">
                <div v-for="(item,index) in msg" :key="index">
                    <component :is="item.model" :msg="item"></component>
                </div>
            </Form-item>
            <Form-item>
                <Button type="primary" @click="submitFn('formItem')">提交</Button>
            </Form-item>
        </Form>
    </div>
</template>
<script>
    import rule from './rule'
    export default {
        data(){
            return{
                formItem:{
                    temid:this.$route.query.temid,
                    name:'',
                    type:'',
                    textid:''
                },
                msg:[],
                typeSel:[
                    {
                        val:1,
                        name:'两值大小比较'
                    },{
                        val:2,
                        name:'计算大小比较'
                    },{
                        val:3,
                        name:'字段显示与否'
                    },{
                        val:4,
                        name:'字段必填项'
                    },{
                        val:5,
                        name:'字段非必填项'
                    }
                ],
                formValidate:{
                    name: [
                        { required: true, message: '规则名称不能为空', trigger: 'change' }
                    ],
                    type: [
                        { required: true, type:'number', message: '请选择类型', trigger: 'change' }
                    ],
                },
            }
        },
        watch:{
            $route(to,from){
                if(to.path == '/templateList/ruleList/addRule'){
                    this.$store.dispatch('parent3ShowFn');
                };
            }
        },
        computed: {
            parent3Show () {
                return this.$store.state.parent3Show;
            }
        },
        created(){
            this.$store.dispatch('parent3ShowFn');
        },
        methods:{
            submitFn(name){
                var _this=this;
                this.$refs[name].validate((valid) => {
                    if(valid){
                        if(_this.msg[0].textid){

                            _this.formItem.textid=_this.msg[0].textid;
                            _this.$http.post('/web/template/addRuleByTemid',_this.formItem).then(function(res){
                                if(res.success){
                                    _this.$Notice.success({
                                        title:'新增模板',
                                        desc:res.message
                                    });
                                    _this.$router.push({path:'/templateList/ruleList',query:{temid:_this.$route.query.temid}});
                                }else{
                                    _this.$Notice.error({
                                        title:'x新增模板',
                                        desc:res.message
                                    });
                                }
                            }).catch(function(res){
                                _this.$Notice.error({
                                    title:'新增规则',
                                    desc:'数据请求失败'
                                });
                            });
                        }else{
                            _this.$Notice.error({
                                title:'新增规则',
                                desc:'规则不全'
                            });
                        }
                    }
                });
            },
            selChangeFn(){
                this.msg=[];
                var model='';
                switch(this.formItem.type){
                    case 1:
                        model='one';
                        break;
                    case 2:
                        model='two';
                        break;
                    default:
                        model='three';
                        break;
                }
                this.msg.push({
                    model:model,
                    type:this.formItem.type,
                    textid:'',
                });
            },
        },
        components:rule
    }
</script>
<style scoped>
    .hd{ background:#464c5b; color:#fff; }
    h3{ background:#dddee1; padding:2px 5px 2px 20px; line-height:30px; margin-top:-1px; }
</style>


// WEBPACK FOOTER //
// src/components/template/addRule.vue